
import { combineReducers } from 'redux';

const INIT_STATE = {
    loading: false,
    success: false,
    error: false,
    message: '',
    data: {},
}
const INITIAL_STATE = 'LANDING';
const GET_DATA = 'GET_DATA';
const INPUT_PASSWORD = 'INPUT_PASSWORD';
const INPUT_JADWAL = 'INPUT_JADWAL';
const PURCHASE_ADD = 'PURCHASE_ADD';

const get_data_transaction = (state = INIT_STATE, action) => {
    switch (action.type) {
        case INITIAL_STATE + '_LOADING_' + GET_DATA + '_TRANSACTION':
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
                message: '',
                data: {}
            }
        case INITIAL_STATE + '_SUCCESS_' + GET_DATA + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                message: 'Success',
                data: {}
            }
        case INITIAL_STATE + '_DATA_' + GET_DATA + '_TRANSACTION':
            return {
                ...state,
                // loading: false,
                // success: true,
                // error: false,
                message: '',
                data: action.data.data
            }
        case INITIAL_STATE + '_ERROR_' + GET_DATA + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                message: 'Error',
                data: {}
            }
        default:
            return state;
    }
}

const input_password_transaction = (state = INIT_STATE, action) => {
    switch (action.type) {
        case INITIAL_STATE + '_LOADING_' + INPUT_PASSWORD + '_TRANSACTION':
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
                message: '',
                data: {}
            }
        case INITIAL_STATE + '_SUCCESS_' + INPUT_PASSWORD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                message: 'Success',
                data: {}
            }
        case INITIAL_STATE + '_DATA_' + INPUT_PASSWORD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                message: 'Success',
                data: {}
            }
        case INITIAL_STATE + '_RESET_' + INPUT_PASSWORD + '_TRANSACTION':
            return {
                state
            }
        case INITIAL_STATE + '_ERROR_' + INPUT_PASSWORD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                message: 'Error',
                data: {}
            }
        default:
            return state;
    }
}

const input_jadwal = (state = { jpt: {}, operator: {}, quota: 0, status: false }, action) => {
    switch (action.type) {
        case INITIAL_STATE + '_INPUT_DATA_JPT_' + INPUT_JADWAL + '_TRANSACTION':
            return {
                ...state,
                jpt: action.data
            }
        case INITIAL_STATE + '_INPUT_DATA_OPERATOR_' + INPUT_JADWAL + '_TRANSACTION':
            return {
                ...state,
                operator: action.data,
                quota: action.quota
            }
        case INITIAL_STATE + '_SUBMIT_JADWAL_' + INPUT_JADWAL + '_TRANSACTION':
            return {
                ...state,
                status: action.status
            }
        default:
            return state
    }
}

const purchase_add_landing = (state = INIT_STATE, action) => {
    switch (action.type) {
        case INITIAL_STATE + '_LOADING_' + PURCHASE_ADD + '_TRANSACTION':
            return {
                ...state,
                loading: true,
                success: false,
                error: false,
                message: '',
                data: {}
            }
        case INITIAL_STATE + '_SUCCESS_' + PURCHASE_ADD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                message: 'Success',
                data: {}
            }
        case INITIAL_STATE + '_DATA_' + PURCHASE_ADD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: true,
                error: false,
                message: 'Success',
                data: {}
            }
        case INITIAL_STATE + '_RESET_' + PURCHASE_ADD + '_TRANSACTION':
            return {
                state
            }
        case INITIAL_STATE + '_ERROR_' + PURCHASE_ADD + '_TRANSACTION':
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                message: action.message,
                data: {}
            }
        default:
            return state;
    }
}


export default combineReducers({
    get_data_transaction,
    input_password_transaction,
    input_jadwal,
    purchase_add_landing
})